import React, { useState, useRef, useEffect } from 'react';
import { MdInfo } from 'react-icons/md';

const InfoPopup = ({ helpText }) => {
    const [isVisible, setIsVisible] = useState(false);
    const popupRef = useRef(null);

    const togglePopup = () => setIsVisible(!isVisible);

    // Close popup if click occurs outside of it
    const handleClickOutside = (event) => {
        if (popupRef.current && !popupRef.current.contains(event.target)) {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <span
            style={{
                position: 'relative',
                display: 'inline-block',
                margin: '0px 6px 0px 6px',
            }}
        >
            <MdInfo
                style={{
                    cursor: 'pointer',
                    color: '##3c97d5',
                    fontSize: '1.2em',
                }}
                onClick={togglePopup}
            />

            {isVisible && (
                <div
                    ref={popupRef}
                    style={{
                        position: 'absolute',
                        color: '#3c97d5',
                        top: '100%',
                        left: '0',
                        marginTop: '4px',
                        padding: '8px',
                        borderRadius: '4px',
                        backgroundColor: '#fff',
                        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
                        zIndex: 1000,
                        width: '300px',
                    }}
                >
                    <p style={{ margin: 0 }}>{helpText}</p>
                </div>
            )}
        </span>
    );
};

export default InfoPopup;
